import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui';

export const BasicInfo = () => {
  return (
    <div className='h-full space-y-4'>
      <div className='grid w-full grid-cols-1 gap-4'>
        <div className='rounded-md bg-white p-4'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40 font-medium text-gray-700'>Tên báo cáo:</Label>
            <div className='flex-1'>
              <FormFieldV2 name='ten_maubc' type='text' className='w-full' />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-40 min-w-40 font-medium text-gray-700'>Tên khác:</Label>
            <div className='flex-1'>
              <FormFieldV2 name='ten_maubc2' type='text' className='w-full' />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
